export default "__VITE_ASSET__D$nkGvci__"